import { render, staticRenderFns } from "./NormalSkd.vue?vue&type=template&id=0285b380"
import script from "./NormalSkd.vue?vue&type=script&lang=js"
export * from "./NormalSkd.vue?vue&type=script&lang=js"
import style0 from "./NormalSkd.vue?vue&type=style&index=0&id=0285b380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports